<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5.56652 12.4958L6.17923 12.5543C6.3393 12.5696 6.50187 12.5774 6.66667 12.5774H9.33333C12.1613 12.5774 14.5 10.2354 14.5 7.28872C14.5 4.34207 12.1613 2 9.33333 2L6.66667 2C3.83874 2 1.5 4.34207 1.5 7.28872C1.5 9.02915 2.31895 10.5658 3.57797 11.5288L4.16667 11.979V13.6362L5.56652 12.4958ZM3.09992 16.44C2.92532 16.5822 2.66667 16.4556 2.66667 16.2279L2.66667 12.7202C1.0474 11.4817 0 9.50974 0 7.28872C0 3.53941 2.98477 0.5 6.66667 0.5L9.33333 0.5C13.0152 0.5 16 3.53941 16 7.28872C16 11.038 13.0152 14.0774 9.33333 14.0774H6.66667C6.45422 14.0774 6.24409 14.0673 6.03672 14.0475L3.09992 16.44Z"
    :fill="fill"
  />
</template>

<script setup lang="ts">
defineProps({
  fill: {
    type: String,
    default: "grey",
  },
});
</script>
